import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import LoadingScreen from "./components/LoadingScreen";
import { Navigate } from 'react-router-dom';
import BuilderEditor from './builder/webflow/BuilderEditor';

import ThemeList from './pages/ThemeList';
import ThemePreview from './pages/ThemePreview';
import ThemeCreate from './pages/ThemeCreate';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // 🔹 Watch Firebase Auth State
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  // 🔹 Show Futuristic Loading Screen while Firebase initializes
  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <Routes>
        {/* Public Pages */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/" element={<Navigate to="/themes" replace />} />
        
        <Route path="/themes" element={<ThemeList />} />
        <Route path="/theme-preview/:themeId" element={<ThemePreview />} />
        <Route path="/theme-create/:themeId" element={<ThemeCreate />} />
        <Route path="/theme/:themeId" element={<ThemePreview />} />

        <Route path="/builder/:siteId" element={<BuilderEditor />} />
        <Route path="/builder/:siteId/:slug" element={<BuilderEditor />} />

        {/* Protected Dashboard */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute user={user}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* Fallback for any unknown route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
